import { fromBase64 } from 'helpers';
import { useEffect, useState } from 'react';
import { processXslt } from 'utils/xslt-transform.helper';

/**
 * Decodes a base64 document and runs it through the XSLT transform.
 * Сырой XML принимается как есть — часть ответов приходит уже расшифрованной.
 * A malformed payload yields `null` instead of throwing — the preview then renders
 * empty rather than taking the whole page down through the error boundary.
 */
export default function useProcessXslt({ base64 }: { base64?: string }) {
  const [data, setData] = useState<DocumentFragment | string | null>(null);

  useEffect(() => {
    if (!base64) {
      setData(null);
      return;
    }

    try {
      const xml = base64.trim().startsWith('<') ? base64 : fromBase64(base64);
      setData(processXslt(xml));
    } catch (error) {
      console.error('Cannot decode document for preview', error);
      setData(null);
    }
  }, [base64]);

  return { data };
}
